// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infinite-scroll-container {
  overflow: visible !important;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/pages/publication/CreatePublication.vue","webpack://./CreatePublication.vue"],"names":[],"mappings":"AAEA;EACE,4BAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.infinite-scroll-container {\n  overflow: visible!important;\n}\n",".infinite-scroll-container {\n  overflow: visible !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
